export const PARTNERS_NAME = '暖哇'
export const PARTNERS_NAME_EN = 'nuamwa'
